import type { ReactNode } from "react";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import {
  Dialog,
  type DialogContentComponentProps,
  type DialogProps,
  DialogContent,
  DialogTrigger,
} from "@tenant/ui";
import defaultStyles from "./Drawer.module.scss";

interface DrawerProps extends DialogProps {}

interface DrawerContentProps extends DialogContentComponentProps {
  children: ReactNode;
  position: "left" | "right";
}

export const Drawer: React.FC<DrawerProps> = (props) => {
  const { children } = props;

  return (
    <Dialog modal={false} {...props}>
      {children}
    </Dialog>
  );
};

export const DrawerContent: React.FC<DrawerContentProps> = (props) => {
  const { position = "left", children } = props;

  const styles = useUiStyles(CoreUiComponents.Drawer, defaultStyles);
  const [, cn] = useModuleBEM(styles, CoreUiComponents.Drawer);

  return (
    <DialogContent
      {...props}
      showOverlay={true}
      className={cn(`drawer-content`, { [position]: true })}
    >
      {children}
    </DialogContent>
  );
};

export const DrawerTrigger = DialogTrigger;
